/* eslint-disable @typescript-eslint/no-explicit-any */
import { Location } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NavigationEnd, Router } from '@angular/router';
import * as CryptoJS from 'crypto-js';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { environment } from '../environments/environment';
const secretKey = 'AEPL_ATCU_Diagnostics_Cloud';

@Injectable({
  providedIn: 'root',
})
export class ApiServiceService {
  private history: string[] = [];
  private primaryUrl: string = environment.primaryUrl;
  private ticketingToolUrl: string = environment.ticketingToolUrl;
  private tcu2gUrl: string = environment.tcu2gUrl;
  private tcu4gUrl: string = environment.tcu4gUrl;
  previousUrl = '';
  constructor(
    private http: HttpClient,
    public snackBar: MatSnackBar,
    private router: Router,
    private location: Location
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.history.push(event.urlAfterRedirects);
      }
    });
  }

  redirect(to: string): void {
    this.router.navigate([to]);
  }

  // Builds query params for a GET request, omitting any that weren't actually passed
  // (undefined/null/empty string) instead of always sending every filter key.
  private buildQueryParams(
    params: Record<string, string | number | undefined | null>
  ): HttpParams {
    let httpParams = new HttpParams();
    Object.keys(params).forEach((key) => {
      const value = params[key];
      if (value !== undefined && value !== null && value !== '') {
        httpParams = httpParams.set(key, value);
      }
    });
    return httpParams;
  }

  downloadAllDeviceReport(): Observable<any> {
    return this.http.get(
      `${this.primaryUrl}/production/downloadAllDeviceReport`
    );
  }

  uploadVahanCertificate(file: any): Observable<any> {
    return this.http.post(
      this.primaryUrl + '/crm/uploadVahanCertificate',
      file
    );
  }

  uploadBackendCertificate(file: any): Observable<any> {
    return this.http.post(
      this.primaryUrl + '/crm/uploadBackendCertificate',
      file
    );
  }

  uploadOtherCertificate(file: any): Observable<any> {
    return this.http.post(
      this.primaryUrl + '/crm/uploadOtherCertificate',
      file
    );
  }

  resendCertificateToCustomer(payload: any): Observable<any> {
    return this.http.post(
      this.primaryUrl + '/crm/resendCertificateToCustomer',
      payload
    );
  }

  downloadCertificate(data: any): Observable<any> {
    return this.http.post(this.primaryUrl + '/crm/downloadCertificate', data);
  }

  saveDispatchData(Payload: any): Observable<any> {
    return this.http.post(this.primaryUrl + '/production/saveDevices', Payload);
  }

  forceStageEnable(id: string, payload: any): Observable<any> {
    const params = this.buildQueryParams({ id });
    return this.http.put(this.primaryUrl + '/crm/skipSecondStage', payload, {
      params,
    });
  }

  addRole(Payload: any): Observable<any> {
    return this.http.post(this.primaryUrl + '/userRole/addrole', Payload);
  }

  getRole(
    pageNo: number,
    size: number,
    search: string,
    hierarchyLevel: string,
    groupId: string
  ): Observable<any> {
    const params = this.buildQueryParams({
      pageNo,
      size,
      search,
      hierarchyLevel,
      groupId,
    });
    return this.http.get(this.primaryUrl + '/userRole/userRoleListPagination', {
      params,
    });
  }

  getRoleById(id: string): Observable<any> {
    const params = this.buildQueryParams({ id });
    return this.http.get(this.primaryUrl + '/userRole/userRoleDetailsById', {
      params,
    });
  }

  updateRole(payload: any): Observable<any> {
    return this.http.put(this.primaryUrl + '/userRole/updateUserById', payload);
  }

  deleteRole(userRole: string): Observable<any> {
    const params = this.buildQueryParams({ userRole });
    return this.http.delete(this.primaryUrl + '/userRole/userRoleDelete', {
      params,
    });
  }

  createUser(Payload: any): Observable<any> {
    return this.http.post(this.primaryUrl + '/user/addUser', Payload);
  }

  getAllUser(
    pageNo: number,
    size: number,
    userRole: string,
    search: string,
    userRefId: string
  ): Observable<any> {
    const params = this.buildQueryParams({
      pageNo,
      size,
      userRole,
      search,
      userRefId,
    });
    return this.http.get(this.primaryUrl + '/user/getAllUser', { params });
  }

  userAssignmentList(search: string, state: string): Observable<any> {
    const params = this.buildQueryParams({ search, state });
    return this.http.get(this.tcu4gUrl + '/user/userAssignmentList', {
      params,
    });
  }

  getAllUser1(
    pageNo: number,
    size: number,
    hierarchyLevel: string,
    groupName: string,
    search: string,
    userRole: string
  ): Observable<any> {
    const params = this.buildQueryParams({
      pageNo,
      size,
      hierarchyLevel,
      groupName,
      search,
      userRole,
    });
    return this.http.get(this.primaryUrl + '/user/getAllUser', { params });
  }

  getSingleUser(id: string): Observable<any> {
    const params = this.buildQueryParams({ id });
    return this.http.get(this.primaryUrl + '/user/fetchUserDetailById', {
      params,
    });
  }

  updateUser(Payload: any): Observable<any> {
    return this.http.put(this.primaryUrl + '/user/updateUserById', Payload);
  }

  addRoleGroup(Payload: any): Observable<any> {
    return this.http.post(this.primaryUrl + '/roleGroup/addRoleGroup', Payload);
  }

  getRoleGroup(pageNo: number, size: number, search: string): Observable<any> {
    const params = this.buildQueryParams({ pageNo, size, search });
    return this.http.get(this.primaryUrl + '/roleGroup/fetchRoleGroupList', {
      params,
    });
  }

  getRoleGroupById(id: string): Observable<any> {
    const params = this.buildQueryParams({ id });
    return this.http.get(this.primaryUrl + '/roleGroup/fetchRoleGroupById', {
      params,
    });
  }

  getAllRoleGroup(): Observable<any> {
    return this.http.get(this.primaryUrl + '/roleGroup/fetchRoleGroup');
  }

  updateRoleGroup(id: string, Payload: any): Observable<any> {
    const params = this.buildQueryParams({ id });
    return this.http.put(
      this.primaryUrl + '/roleGroup/updateRoleGroup',
      Payload,
      { params }
    );
  }

  deleteRoleGroup(id: string): Observable<any> {
    const params = this.buildQueryParams({ id });
    return this.http.delete(this.primaryUrl + '/roleGroup/deleteRoleGroup', {
      params,
    });
  }

  userLogin(Payload: any): Observable<any> {
    return this.http.post(this.primaryUrl + '/user/login', Payload);
  }

  loginReset(Payload: any): Observable<any> {
    return this.http.post(this.primaryUrl + '/user/loginReset', Payload);
  }

  deleteUser(id: string): Observable<any> {
    const params = this.buildQueryParams({ id });
    return this.http.delete(this.primaryUrl + '/user/DeleteUserById', {
      params,
    });
  }

  userChangePassword(Payload: any): Observable<any> {
    return this.http.put(this.primaryUrl + '/user/changePassword', Payload);
  }

  // Merges productionCount + barGraph into one call for the Device Dashboard.
  getDeviceDashboardSummary(): Observable<any> {
    return this.http.get(this.primaryUrl + '/production/fetchDashboardSummary');
  }

  // Single paginated/searchable list backing every Device Dashboard tab
  // except Active AIS140 Certified Devices (which stays on getDeviceData below - a
  // different collection). `bucket` is one of
  // total|dispatched|installed|activity|firmware|state; `filterValue` is the
  // bucket-specific extra filter (day-bucket code, firmware version(s), or a
  // government-server id/"Unassign") where applicable.
  getDeviceDashboardList(
    bucket: string,
    pageNo: number,
    size: number,
    search: string,
    filterValue: string
  ): Observable<any> {
    const params = this.buildQueryParams({
      bucket,
      pageNo,
      size,
      search,
      filterValue,
    });
    return this.http.get(this.primaryUrl + '/production/fetchDashboardList', {
      params,
    });
  }

  // Single export endpoint backing the download button on every Device
  // Dashboard tab except Total Production (its own static daily dump) and
  // Active AIS140 Certified Devices (downloadCertifiedDeviceReport, a different
  // collection). Same bucket/filterValue semantics as getDeviceDashboardList.
  // `modelName` additionally narrows to one model, for the "Device Model
  // Wise" popups' own per-model download buttons.
  getDeviceDashboardDownload(
    bucket: string,
    search: string,
    filterValue: string,
    modelName = ''
  ): Observable<any> {
    const params = this.buildQueryParams({
      bucket,
      search,
      filterValue,
      modelName,
    });
    return this.http.get(
      this.primaryUrl + '/production/downloadDashboardList',
      { params }
    );
  }

  deviceDashboard(imei: string): Observable<any> {
    const params = this.buildQueryParams({ imei });
    return this.http.get(this.primaryUrl + '/production/deviceDashboard', {
      params,
    });
  }

  createManualOtaBatch(payload: any): Observable<any> {
    return this.http.post(
      this.primaryUrl + '/otaBatch/createManualOtaBatch',
      payload
    );
  }

  createBulkOtaBatch(payload: any, file: File): Observable<any> {
    const formData = new FormData();

    formData.append('file', file);
    formData.append('name', payload.name);
    formData.append('description', payload.description);
    formData.append('createdBy', payload.createdBy);

    formData.append('commandArray', JSON.stringify(payload.commandArray));

    return this.http.post(
      this.primaryUrl + '/otaBatch/createBulkOtaBatch',
      formData
    );
  }

  createCustomOtaBatch(payload: any, file: File): Observable<any> {
    const formData = new FormData();

    formData.append('file', file);
    formData.append('name', payload.name);
    formData.append('description', payload.description);
    formData.append('createdBy', payload.createdBy);

    formData.append('command', JSON.stringify(payload.command));

    return this.http.post(
      this.primaryUrl + '/otaBatch/createCustomOtaBatch',
      formData
    );
  }

  createOtaCommand(payload: any): Observable<any> {
    return this.http.post(
      this.primaryUrl + '/otaMaster/createOtaCommand',
      payload
    );
  }

  updateOtaCommand(id: string, Payload: any): Observable<any> {
    return this.http.put(
      this.primaryUrl + '/otaMaster/updateOtaCommand/' + id,
      Payload
    );
  }

  getOtaCommandList(
    pageNo: number,
    size: number,
    search: string,
    filter: string
  ): Observable<any> {
    const params = this.buildQueryParams({
      pageNo,
      size,
      searchParam: search,
      filter,
    });
    return this.http.get(this.primaryUrl + '/otaMaster/getOtaCommandList', {
      params,
    });
  }

  deleteOtaCommand(id: string): Observable<any> {
    return this.http.delete(
      this.primaryUrl + '/otaMaster/deleteOtaCommand/' + id
    );
  }

  createFotaBatch(Payload: any, file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('deviceData', JSON.stringify(Payload));

    return this.http.post(this.primaryUrl + '/fota/createFotaBatch', formData);
  }

  fetchFotaBatchList(
    pageNo: number,
    size: number,
    search: string
  ): Observable<any> {
    const params = this.buildQueryParams({ pageNo, size, search });
    return this.http.get(this.primaryUrl + '/fota/fetchFotaBatchList', {
      params,
    });
  }

  abortFotaBatch(id: string, abortedBy: string): Observable<any> {
    const params = this.buildQueryParams({ id, abortedBy });
    return this.http.delete(this.primaryUrl + '/fota/abortFotaBatch', {
      params,
    });
  }

  numberOfFOTAInitiated(): Observable<any> {
    return this.http.get(this.primaryUrl + '/fota/numberOfFOTAInitiated');
  }

  downloadAllFOTAInitiatedDevicesReport(): Observable<any> {
    return this.http.get(
      this.primaryUrl + '/fota/downloadAllFOTAInitiatedDevicesReport'
    );
  }

  downloadAllDevicesUnderFOTAProcessReport(): Observable<any> {
    return this.http.get(
      this.primaryUrl + '/fota/downloadAllDevicesUnderFOTAProcessReport'
    );
  }

  getFOTADevicesHistory(imei: string): Observable<any> {
    const params = this.buildQueryParams({ imei });
    return this.http.get(this.primaryUrl + '/fota/getFOTADevicesHistory', {
      params,
    });
  }

  getOTADevicesHistory(imei: string): Observable<any> {
    const params = this.buildQueryParams({ imei });
    return this.http.get(this.primaryUrl + '/ota/getOTADevicesHistory', {
      params,
    });
  }

  downloadAllOTAPendingDevicesReport(): Observable<any> {
    return this.http.get(
      this.primaryUrl + '/ota/downloadAllOTAPendingDevicesReport'
    );
  }

  abortFotaDevice(id: string, abortedBy: string): Observable<any> {
    const params = this.buildQueryParams({ id, abortedBy });
    return this.http.get(this.primaryUrl + '/fota/abortFotaDevice', {
      params,
    });
  }

  getBatchData(pageNo: number, size: number, search: string): Observable<any> {
    const params = this.buildQueryParams({ pageNo, size, search });
    return this.http.get(this.primaryUrl + '/ota/fetchOtaBatchList', {
      params,
    });
  }

  deleteOtaBatch(id: string, abortedBy: string): Observable<any> {
    const params = this.buildQueryParams({ id, abortedBy });
    return this.http.put(this.primaryUrl + '/ota/deleteOtaBatch', '', {
      params,
    });
  }

  deleteOtaBatchDevice(id: string, abortedBy: string): Observable<any> {
    const params = this.buildQueryParams({ id, abortedBy });
    return this.http.put(this.primaryUrl + '/ota/deleteOtaBatchDevice', '', {
      params,
    });
  }

  getBatchDataSingle(
    pageNo: number,
    size: number,
    search: string,
    batchRefId: string,
    kpiSelected: string
  ): Observable<any> {
    const params = this.buildQueryParams({
      pageNo,
      size,
      search,
      batchRefId,
      kpiSelected,
    });
    return this.http.get(this.primaryUrl + '/ota/fetchOtaBatchKpi', {
      params,
    });
  }

  downloadOtaBatchDevicesReport(batchRefId: string): Observable<any> {
    const params = this.buildQueryParams({ batchRefId });
    return this.http.get(
      this.primaryUrl + '/ota/downloadOtaBatchDevicesReport',
      { params }
    );
  }

  getAllMyActivity(
    pageNo: number,
    size: number,
    id: string,
    fromDate: string,
    toDate: string,
    state: string,
    assignTo: string,
    ticketStatusFilter: string,
    dealer: string,
    initiatedBy: string,
    kpiCardSelected: string,
    search: string,
    deviceType: string,
    ticketCompletedAtFromDate: string,
    ticketCompletedAtToDate: string,
    tatType: string
  ): Observable<any> {
    const params = this.buildQueryParams({
      pageNo,
      size,
      id,
      search,
      state,
      dealer,
      toDate,
      fromDate,
      ticketStatusFilter,
      assignTo,
      initiatedBy,
      deviceType,
      kpiCardSelected,
      ticketCompletedAtFromDate,
      ticketCompletedAtToDate,
      tatType,
    });
    return this.http.get(this.tcu4gUrl + '/crm/getAIS140TicketList', {
      params,
    });
  }

  editTickets(payload: any): Observable<any> {
    return this.http.post(this.tcu4gUrl + '/crm/editTickets', payload);
  }

  downloadTicketDetailsReport(
    fromDate: string,
    toDate: string,
    state: string,
    assignTo: string,
    ticketStatusFilter: string,
    dealer: string,
    initiatedBy: string,
    kpiCardSelected: string,
    search: string,
    deviceType: string,
    ticketCompletedAtFromDate: string,
    ticketCompletedAtToDate: string
  ): Observable<any> {
    const params = this.buildQueryParams({
      search,
      state,
      dealer,
      toDate,
      fromDate,
      ticketStatusFilter,
      assignTo,
      initiatedBy,
      deviceType,
      kpiCardSelected,
      ticketCompletedAtFromDate,
      ticketCompletedAtToDate,
    });
    return this.http.get(this.tcu4gUrl + '/crm/downloadTicketDetailsReport', {
      params,
    });
  }

  resendTicketStatus(
    fromDate: string,
    toDate: string,
    state: string,
    assignTo: string,
    ticketStatusFilter: string,
    dealer: string,
    initiatedBy: string,
    kpiCardSelected: string,
    search: string,
    deviceType: string,
    ticketCompletedAtFromDate: string,
    ticketCompletedAtToDate: string
  ): Observable<any> {
    const params = this.buildQueryParams({
      search,
      state,
      dealer,
      toDate,
      fromDate,
      ticketStatusFilter,
      assignTo,
      initiatedBy,
      deviceType,
      kpiCardSelected,
      ticketCompletedAtFromDate,
      ticketCompletedAtToDate,
    });
    return this.http.get(this.tcu4gUrl + '/crm/resendTicketStatus', {
      params,
    });
  }

  downloadTATReport(
    fromDate: string,
    toDate: string,
    state: string,
    assignTo: string,
    ticketStatusFilter: string,
    dealer: string,
    initiatedBy: string,
    kpiCardSelected: string,
    search: string,
    deviceType: string,
    email: string,
    ticketCompletedAtFromDate: string,
    ticketCompletedAtToDate: string,
    tatType: string
  ): Observable<any> {
    const params = this.buildQueryParams({
      search,
      state,
      dealer,
      toDate,
      fromDate,
      ticketStatusFilter,
      assignTo,
      initiatedBy,
      deviceType,
      email,
      kpiCardSelected,
      ticketCompletedAtFromDate,
      ticketCompletedAtToDate,
      tatType,
    });
    return this.http.get(this.primaryUrl + '/crm/getTicketTATReport', {
      params,
    });
  }

  getTicketDetailsById(uinNo: string, refId: string): Observable<any> {
    const params = this.buildQueryParams({ uinNo, refId });
    return this.http.get(this.primaryUrl + '/crm/getTicketDetailsById', {
      params,
    });
  }

  fetchTicketDashboardGraph(
    id: string,
    fromDate: string,
    toDate: string,
    state: string,
    assignTo: string,
    ticketStatusFilter: string,
    dealer: string,
    initiatedBy: string,
    deviceType: string,
    ticketCompletedAtFromDate: string,
    ticketCompletedAtToDate: string,
    tatType: string
  ): Observable<any> {
    const params = this.buildQueryParams({
      state,
      id,
      dealer,
      toDate,
      fromDate,
      ticketStatusFilter,
      assignTo,
      initiatedBy,
      deviceType,
      ticketCompletedAtFromDate,
      ticketCompletedAtToDate,
      tatType,
    });
    return this.http.get(this.tcu4gUrl + '/crm/fetchTicketDashboardGraph', {
      params,
    });
  }

  addTicketStage(Payload: any): Observable<any> {
    return this.http.post(this.primaryUrl + '/crm/saveTicketStageUI', Payload);
  }

  fotaBatchDeviceListByBatchId2G(
    pageNo: number,
    size: number,
    id: string,
    firmwareVersion: string,
    state: string,
    searchField: string
  ): Observable<any> {
    const params = this.buildQueryParams({
      pageNo,
      size,
      id,
      firmwareVersion,
      state,
      searchField,
    });
    return this.http.get(this.tcu2gUrl + '/fota/fotaBatchDeviceListByBatchId', {
      params,
    });
  }

  twoGFotaBatchDevice(payload: any): Observable<any> {
    return this.http.post(
      this.primaryUrl + '/fota/twoGFotaBatchDevice',
      payload
    );
  }

  createAutoAis140FotaBatch(payload: any): Observable<any> {
    return this.http.post(
      this.primaryUrl + '/fotaBatch/createAutoAis140FotaBatch',
      payload
    );
  }

  getTicketStage(
    stage: string,
    ticketNo: string,
    associated: string,
    VIN_NO: string
  ): Observable<any> {
    const params = this.buildQueryParams({
      stage,
      ticketNo,
      associated,
      VIN_NO,
    });
    return this.http.get(this.primaryUrl + '/crm/fetchTicketStage', {
      params,
    });
  }

  getDeviceByTicketPagination(
    ticketNo: string,
    VIN_NO: string
  ): Observable<any> {
    const params = this.buildQueryParams({ ticketNo, VIN_NO });
    return this.http.get(this.primaryUrl + '/crm/fetchTicketStageHistory', {
      params,
    });
  }

  saveServerData(Payload: any): Observable<any> {
    return this.http.post(this.primaryUrl + '/server/saveServerData', Payload);
  }

  addFirmware(Payload: any): Observable<any> {
    return this.http.post(
      this.primaryUrl + '/server/saveFirmwareData',
      Payload
    );
  }

  updateServer(id: string, Payload: any): Observable<any> {
    const params = this.buildQueryParams({ id });
    return this.http.put(
      this.primaryUrl + '/server/updateServerData',
      Payload,
      {
        params,
      }
    );
  }

  deleteFirmwareVersion(id: string): Observable<any> {
    const params = this.buildQueryParams({ id });
    return this.http.delete(this.primaryUrl + '/server/deleteFirmwareVersion', {
      params,
    });
  }

  updateFirmwareExpectedFirmwareVersionData(
    firmwareId: string,
    Payload: any
  ): Observable<any> {
    const params = this.buildQueryParams({ firmwareId });
    return this.http.put(
      this.primaryUrl + '/server/updateFirmwareExpectedFirmwareVersionData',
      Payload,
      { params }
    );
  }

  deleteGovtServer(id: string): Observable<any> {
    const params = this.buildQueryParams({ id });
    return this.http.delete(this.primaryUrl + '/server/deleteServer', {
      params,
    });
  }

  getGovtServerList(
    pageNo: number,
    size: number,
    search: string
  ): Observable<any> {
    const params = this.buildQueryParams({ pageNo, size, search });
    return this.http.get(this.primaryUrl + '/server/getServerData', {
      params,
    });
  }

  downloadAllServerDetailsReport(): Observable<any> {
    return this.http.get(
      `${this.primaryUrl}/server/downloadAllServerDetailsReport`
    );
  }

  getGovtServerListRefId(id: string): Observable<any> {
    const params = this.buildQueryParams({ id });
    return this.http.get(this.primaryUrl + '/server/getServerDataByUId', {
      params,
    });
  }

  getAllGovtServerList(): Observable<any> {
    return this.http.get(this.primaryUrl + '/server/getAllServerData');
  }

  getTicketAssignmentMasterList(): Observable<any> {
    return this.http.get(
      this.primaryUrl + '/crm/getTicketAssignmentMasterList'
    );
  }

  updateTicketAssignmentMasterList(
    _id: string,
    states: any[]
  ): Observable<any> {
    return this.http.put(
      this.primaryUrl + '/crm/updateTicketAssignmentMasterList',
      { _id, states }
    );
  }

  saveAssignmentById(_id: string, payload: any[]): Observable<any> {
    return this.http.post(
      this.primaryUrl + '/user/saveAssignmentById/' + _id,
      payload
    );
  }

  getDefaultTicketAssignedToUser(): Observable<any> {
    return this.http.get(
      this.primaryUrl + '/crm/getDefaultTicketAssignedToUser'
    );
  }
  updateDefaultTicketAssignedToUser(_id: string): Observable<any> {
    return this.http.put(
      this.primaryUrl + '/crm/updateDefaultTicketAssignedToUser',
      { _id }
    );
  }

  getFotaNotRequiredStateList(): Observable<any> {
    return this.http.get(this.primaryUrl + '/crm/getFotaNotRequiredStateList');
  }

  updateFotaNotRequiredStateList(states: any[]): Observable<any> {
    return this.http.put(
      this.primaryUrl + '/crm/updateFotaNotRequiredStateList',
      { states }
    );
  }

  getAllServerFirmwareDetails(): Observable<any> {
    return this.http.get(
      this.primaryUrl + '/server/getAllServerFirmwareDetails'
    );
  }

  getFirmwareList(
    pageNo: number,
    size: number,
    search: string
  ): Observable<any> {
    const params = this.buildQueryParams({ pageNo, size, search });
    return this.http.get(this.primaryUrl + '/model/getFirmwareData', {
      params,
    });
  }

  deleteFirmware(id: string): Observable<any> {
    const params = this.buildQueryParams({ id });
    return this.http.delete(this.primaryUrl + '/model/deleteFirmware', {
      params,
    });
  }

  saveFirmware(Payload: any): Observable<any> {
    return this.http.post(this.primaryUrl + '/model/saveFirmware', Payload);
  }

  getFirmwareDataById(id: string): Observable<any> {
    const params = this.buildQueryParams({ id });
    return this.http.get(this.primaryUrl + '/model/getFirmwareDataById', {
      params,
    });
  }

  getIgnitionStatus(vinNo: string): Observable<any> {
    return this.http.get(this.primaryUrl + '/crm/getIgnitionStatus/' + vinNo);
  }

  updateFirmwareData(id: string, Payload: any): Observable<any> {
    const params = this.buildQueryParams({ id });
    return this.http.put(
      this.primaryUrl + '/model/updateFirmwareData',
      Payload,
      { params }
    );
  }

  getAllVahanRegiCount(
    state: string,
    dealer: string,
    toDate: string,
    fromDate: string,
    assignTo: string,
    initiatedBy: string,
    ticketStatusFilter: string,
    deviceType: string,
    search: string,
    id: string,
    ticketCompletedAtFromDate: string,
    ticketCompletedAtToDate: string,
    tatType: string
  ): Observable<any> {
    const params = this.buildQueryParams({
      state,
      dealer,
      toDate,
      fromDate,
      assignTo,
      initiatedBy,
      ticketStatusFilter,
      deviceType,
      search,
      id,
      ticketCompletedAtFromDate,
      ticketCompletedAtToDate,
      tatType,
    });
    return this.http.get(this.tcu4gUrl + '/crm/getDashCounts', { params });
  }

  downloadFotaBatchSummaryReport(
    fromDate: string,
    toDate: string,
    fromId: string,
    toId: string,
    idArray: string
  ): Observable<any> {
    const params = this.buildQueryParams({
      fromDate,
      toDate,
      fromId,
      toId,
      idArray,
    });
    return this.http.get(
      this.primaryUrl + '/fota/downloadFotaBatchSummaryReport',
      { params }
    );
  }

  getOtaBatchReports(
    fromDate: string,
    toDate: string,
    fromId: string,
    toId: string
  ): Observable<any> {
    const params = this.buildQueryParams({ fromDate, toDate, fromId, toId });
    return this.http.get(this.primaryUrl + '/ota/getOtaOverallBatchReport', {
      params,
    });
  }

  downloadDeviceInFotaBatchSummaryReport(
    fromDate: string,
    toDate: string,
    fromId: string,
    toId: string,
    idArray: string,
    imeiArray: string
  ): Observable<any> {
    const params = this.buildQueryParams({
      fromDate,
      toDate,
      fromId,
      toId,
      idArray,
      imeiArray,
    });
    return this.http.get(
      this.primaryUrl + '/fota/downloadDeviceInFotaBatchSummaryReport',
      { params }
    );
  }

  downloadOtaOverallBatchDeviceReport(
    fromDate: string,
    toDate: string,
    fromId: string,
    toId: string
  ): Observable<any> {
    const params = this.buildQueryParams({ fromDate, toDate, fromId, toId });
    return this.http.get(
      this.primaryUrl + '/ota/downloadOtaOverallBatchDeviceReport',
      { params }
    );
  }

  downloadOtaBatchSummaryReport(
    fromDate: string,
    toDate: string,
    fromId: string,
    toId: string
  ): Observable<any> {
    const params = this.buildQueryParams({ fromDate, toDate, fromId, toId });
    return this.http.get(
      this.primaryUrl + '/ota/downloadOtaBatchSummaryReport',
      { params }
    );
  }

  assignMultiUser(Payload: any): Observable<any> {
    return this.http.put(this.primaryUrl + '/crm/assignMultiUser', Payload);
  }

  getDispatchDeviceList(
    pageNo: number,
    size: number,
    search: string
  ): Observable<any> {
    const params = this.buildQueryParams({ pageNo, size, search });
    return this.http.get(this.primaryUrl + '/dispatch/getDispatchData', {
      params,
    });
  }

  getDispatchDeviceById(id: string): Observable<any> {
    const params = this.buildQueryParams({ id });
    return this.http.get(this.primaryUrl + '/dispatch/dispatchDeviceById', {
      params,
    });
  }

  downloadDispatchDeviceReport(search: string): Observable<any> {
    const params = this.buildQueryParams({ search });
    return this.http.get(
      this.primaryUrl + '/dispatch/downloadDispatchDeviceReport',
      { params }
    );
  }

  saveDealerData(payload: any): Observable<any> {
    return this.http.post(this.primaryUrl + '/dealer/saveDealerData', payload);
  }

  getAllDealers(pageNo: number, size: number, search: string): Observable<any> {
    const params = this.buildQueryParams({ pageNo, size, search });
    return this.http.get(this.tcu4gUrl + '/dealer/getDealers', { params });
  }

  getDealerByState(state: string): Observable<any> {
    const params = this.buildQueryParams({ state });
    return this.http.get(this.tcu4gUrl + '/dealer/getDealerByState', {
      params,
    });
  }

  downloadDealerMasterData(search: string): Observable<any> {
    const params = this.buildQueryParams({ search });
    return this.http.get(this.tcu4gUrl + '/dealer/downloadDealerDataReport', {
      params,
    });
  }

  getDealerByDealerCode(dealerCode: string): Observable<any> {
    const params = this.buildQueryParams({ dealerCode });
    return this.http.get(this.tcu4gUrl + '/dealer/getDealerById', { params });
  }

  getDealerById(id: string): Observable<any> {
    const params = this.buildQueryParams({ id });
    return this.http.get(this.tcu4gUrl + '/dealer/getDealerById', { params });
  }

  updateDealerData(id: string, payload: any): Observable<any> {
    const params = this.buildQueryParams({ id });
    return this.http.put(this.tcu4gUrl + '/dealer/updateDealer', payload, {
      params,
    });
  }

  updateDispatchDeviceData(payload: any): Observable<any> {
    return this.http.post(
      this.primaryUrl + '/dispatch/updateDispatchDeviceData',
      payload
    );
  }

  deleteDealerData(id: string): Observable<any> {
    const params = this.buildQueryParams({ id });
    return this.http.delete(this.tcu4gUrl + '/dealer/deleteDealer', {
      params,
    });
  }

  deleteDispatchDeviceData(
    deviceId: string,
    dispatchDeviceId: string
  ): Observable<any> {
    const params = this.buildQueryParams({ deviceId, dispatchDeviceId });
    return this.http.delete(
      this.primaryUrl + '/dispatch/deleteDispatchDeviceData',
      { params }
    );
  }

  getDealers(pageNo: number, size: number, search: string): Observable<any> {
    const params = this.buildQueryParams({ pageNo, size, search });
    return this.http.get(this.primaryUrl + '/dealer/getDealerDetails', {
      params,
    });
  }

  fotaBatchDeviceListByBatchId(
    pageNo: number,
    size: number,
    id: string,
    firmwareVersion: string,
    state: string,
    searchField: string,
    kpiCardSelected: string
  ): Observable<any> {
    const params = this.buildQueryParams({
      pageNo,
      size,
      id,
      firmwareVersion,
      state,
      searchField,
      kpiCardSelected,
    });
    return this.http.get(
      this.primaryUrl + '/fota/fotaBatchDeviceListByBatchId',
      { params }
    );
  }

  downloadFotaBatchDeviceReport(id: string): Observable<any> {
    const params = this.buildQueryParams({ id });
    return this.http.get(
      this.primaryUrl + '/fota/downloadFotaBatchDeviceReport',
      { params }
    );
  }

  startFota(id: string, startedBy: string): Observable<any> {
    const params = this.buildQueryParams({ id, startedBy });
    return this.http.get(this.primaryUrl + '/fota/startFota', { params });
  }

  fetchFotaBatchDetailsById(id: string): Observable<any> {
    const params = this.buildQueryParams({ id });
    return this.http.get(this.primaryUrl + '/fota/fetchFotaBatchDetailsById', {
      params,
    });
  }

  getApiLogsData(
    pageNo: number,
    size: number,
    search: string
  ): Observable<any> {
    const params = this.buildQueryParams({ pageNo, size, search });
    return this.http.get(this.primaryUrl + '/crm/fetchApiLogs', { params });
  }

  getApiReqLogsData(
    pageNo: number,
    size: number,
    search: string
  ): Observable<any> {
    const params = this.buildQueryParams({ pageNo, size, search });
    return this.http.get(this.primaryUrl + '/crm/fetchApiReqLogs', {
      params,
    });
  }

  getApiResLogsData(
    pageNo: number,
    size: number,
    search: string
  ): Observable<any> {
    const params = this.buildQueryParams({ pageNo, size, search });
    return this.http.get(this.primaryUrl + '/crm/fetchApiResLogs', {
      params,
    });
  }

  saveFirmwareVersion(data: any): Observable<any> {
    return this.http.post(
      this.primaryUrl + '/fileCsv/saveFirmwareVersion',
      data
    );
  }

  getFiledata(pageNo: number, size: number, search: any): Observable<any> {
    const params = this.buildQueryParams({ pageNo, size, search });
    return this.http.get(this.primaryUrl + '/fileCsv/getfile', { params });
  }

  deleteFile(id: string): Observable<any> {
    const params = this.buildQueryParams({ id });
    return this.http.delete(this.primaryUrl + '/fileCsv/deletefile', {
      params,
    });
  }

  getDelaerFotaData(
    pageNo: number,
    size: number,
    search: string
  ): Observable<any> {
    const params = this.buildQueryParams({ pageNo, size, search });
    return this.http.get(this.primaryUrl + '/dealerdata/getdelaerfota', {
      params,
    });
  }

  downloadDealerFotaReport(search: string): Observable<any> {
    const params = this.buildQueryParams({ search });
    return this.http.get(
      this.primaryUrl + '/dealerdata/downloadDealerFotaReport',
      { params }
    );
  }

  saveCrmData(data: any): Observable<any> {
    return this.http.post(
      `${this.ticketingToolUrl}/crm/generateTicketsUi`,
      data
    );
  }

  completeTicket(data: any): Observable<any> {
    return this.http.post(`${this.ticketingToolUrl}/crm/completeTicket`, data);
  }

  saveDeviceState(data: any): Observable<any> {
    return this.http.post(
      `${this.primaryUrl}/deviceConfigs/saveDeviceState`,
      data
    );
  }

  getDeviceSystemActivityLog(
    pageNo: number,
    size: number,
    search: string,
    filter: string
  ): Observable<any> {
    const params = this.buildQueryParams({ pageNo, size, search, filter });
    return this.http.get(
      this.primaryUrl + '/deviceConfigs/getDeviceSystemActivityLog',
      { params }
    );
  }

  downloadDeviceSystemActivityLog(
    search: string,
    filter: string
  ): Observable<any> {
    const params = this.buildQueryParams({ search, filter });
    return this.http.get(
      this.primaryUrl + '/deviceConfigs/downloadDeviceSystemActivityLog',
      { params }
    );
  }

  saveDeviceVin(data: any): Observable<any> {
    return this.http.post(
      `${this.primaryUrl}/deviceConfigs/saveDeviceVin`,
      data
    );
  }

  getSimDataDetails(
    pageNo: number,
    size: number,
    search: string,
    simStatus: string,
    activationStatus: string
  ): Observable<any> {
    const params = this.buildQueryParams({
      pageNo,
      size,
      search,
      simStatus,
      activationStatus,
    });
    return this.http.get(this.primaryUrl + '/report/simDataList', {
      params,
    });
  }

  getSimDataDetailsExport(): Observable<any> {
    return this.http.get(this.primaryUrl + '/report/downloadSimData');
  }


  createManualFota(payload: any): Observable<any> {
    return this.http.post(this.primaryUrl + '/fota/createManualFota', payload);
  }

  createManualOta(payload: any): Observable<any> {
    return this.http.post(
      this.primaryUrl + '/otaBatch/createManualOta',
      payload
    );
  }

  back() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.previousUrl = event.url;
      });

    this.location.back();
  }

  openSnackbar(message: string) {
    return this.snackBar.open(message, 'Close', {
      verticalPosition: 'bottom',
      horizontalPosition: 'right',
      duration: 2000,
      panelClass: ['snackbarStyle'],
    });
  }

  encryptData(message: string) {
    if (message) {
      return CryptoJS.AES.encrypt(
        JSON.stringify(message),
        secretKey
      ).toString();
    } else {
      return '';
    }
  }

  decryptData(message: string) {
    if (message) {
      const bytes = CryptoJS.AES.decrypt(message, secretKey);
      const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      return decryptedData;
    }
    return '';
  }
}
